import { ArrowRight, Clock3, Mail, MapPin, UsersRound } from "lucide-react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { headerImageStyle } from "../lib/headerImages";
import { PublicPageSkeleton } from "../components/LoadingSkeleton";

export function TrainingPage() {
  const { content, loading } = useContent();
  const { training, contact } = content;

  if (loading) return <PublicPageSkeleton variant="standard" />;

  return (
    <>
      <section className="page-hero page-hero--training" style={headerImageStyle(content.headers.training)}><div className="page-width"><span className="eyebrow eyebrow--light"><span /> Mitspielen & besser werden</span><h1>Training</h1><p>{training.intro}</p></div></section>
      <section className="section page-width training-page-grid">
        <div>
          <span className="eyebrow"><span /> Unsere Trainingszeiten</span>
          <h2>{training.title}</h2>
          <p>Unsere Trainingsgruppen sind offen für unterschiedliche Spielstärken. Für das erste Training brauchst du nur Hallenschuhe, bequeme Sportkleidung und Lust auf Tischtennis.</p>
        </div>
        <div className="training-table-card">
          <div className="training-table-head"><span><Clock3 /></span><div><strong>Trainingsplan</strong><small>Unsere regelmäßigen Hallenzeiten</small></div></div>
          {training.slots.map((slot, index) => (
            <div key={slot.day} className="training-row">
              <div className="training-day"><span>{String(index + 1).padStart(2, "0")}</span><div><small>Trainingstag</small><h3>{slot.day}</h3></div></div>
              <div className="training-slot"><span><UsersRound /> Jugend</span><strong><Clock3 /> {slot.youth}</strong></div>
              <div className="training-slot"><span><UsersRound /> Erwachsene</span><strong><Clock3 /> {slot.adults}</strong></div>
            </div>
          ))}
        </div>
      </section>

      {training.noteVisible && (
        <section className="section training-notice-section">
          <div className={`page-width training-info-grid ${training.noteImage ? "" : "training-info-grid--text-only"}`}>
            {training.noteImage && <div className="training-photo"><img src={training.noteImage} alt="Tischtennistraining beim TTC Rehlingen" loading="lazy" /><span>Dein Verein.<br />Dein Spiel.</span></div>}
            <div className="info-card"><span className="info-card-icon"><Mail /></span><span className="eyebrow"><span /> Wichtig für neue Talente</span><h2>{training.noteTitle}</h2><p>{training.noteText}</p>{training.noteButtonLabel.trim() && <a className="button button--dark" href={training.noteButtonHref || `mailto:${contact.email}?subject=Anfrage Jugendtraining`}>{training.noteButtonLabel} <ArrowRight size={17} /></a>}</div>
          </div>
        </section>
      )}

      <section className="section page-width location-card">
        <div><MapPin /><div><span className="eyebrow"><span /> Hier trainieren wir</span><h2>{training.location}</h2><p>{training.address}</p></div></div>
        <a className="button button--outline" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(training.address)}`} target="_blank" rel="noreferrer">Route öffnen <ArrowRight size={17} /></a>
      </section>
      <section className="page-width join-card join-card--training"><div><span className="eyebrow eyebrow--light"><span /> Noch unsicher?</span><h2>Komm einfach zum Probetraining.</h2></div><p>Wir beantworten deine Fragen und finden die passende Trainingsgruppe.</p><Link className="button button--light" to="/kontakt">Jetzt Kontakt aufnehmen <ArrowRight size={18} /></Link></section>
    </>
  );
}
